<template>
    <div id="Settings_Header">
        <div class="HeaderRow">
            <div id="FactoryFilterContainer">
                <div class="FilterTitle">工場</div>
                <div class="FilterElement RoundShadowElement">
                    <GenericMultiDropdown id="FactoryFilter" ref="FactoryFilter" :-allow-multiple=true :-close-on-select=false :InputPlaceholder="'工場を選択'" :options="FactoryOptions" label="Test" :OnChange="OnFactoryChange" />
                </div>
            </div>
            <div id="SeriesFilterContainer">
                <div class="FilterTitle">シリーズ</div>
                <div class="FilterElement RoundShadowElement">
                    <GenericMultiDropdown id="SeriesFilter" ref="SeriesFilter" :-allow-multiple=true :-close-on-select=false :InputPlaceholder="'シリーズを選択'" :options="SeriesOptions" label="Test" :OnChange="OnSeriesChange" />
                </div>
            </div>
            <div id="BrandFilterContainer">
                <div class="FilterTitle">ブランド</div>
                <div class="FilterElement RoundShadowElement">
                    <GenericMultiDropdown id="BrandFilter" ref="BrandFilter" :-allow-multiple=true :-close-on-select=false :InputPlaceholder="'ブランドを選択'" :options="BrandOptions" label="Test" :OnChange="OnBrandChange" />
                </div>
            </div>
            <!-- <div id="FilterFromContainer">
                <div class="FilterTitle">輸入日</div>
                <div class="row mt-1 border" v-show="show.calendar">
                    <DatePicker
                        v-model:="SelectedFilterDate"
                        @onSelect="UpdatedFilterDate"
                        :next-prev-icon="true"
                        :last-month="todayDt"
                        :first-month="firstDt"
                        :enable-second-calendar="true"
                    />
                </div>
                <div id='DatePicker' class="FilterElement RoundShadowElement" @click="ShowCalendar()">{{ SelectedFilterDate[0].format("MMM, YYYY") }} - {{ SelectedFilterDate[1].format("MMM, YYYY") }}</div>
            </div> -->
            <div id="SearchContainer">
                <!-- <div class="FilterTitle">サーチ</div>
                <div class="FilterElement RoundShadowElement">searchbar</div> -->
                <TextSearch :Label="'サーチ'" :Placeholder="'商品名'" :OnChange="OnSearchChange" />
            </div>
        </div>
        <div class="HeaderRow">
            <div class="FilterContainer" style="margin-top: -25px; margin-left: 25px;">
                <div class="FilterTitle">年</div>
                <div>
                    <VueSlider v-model="FilterYear" :min="MinFilterYear" :max="MaxFilterYear" :maxRange="MaxFilterYear" marks @drag-end="OnFilterYearChange" />
                </div>
            </div>
            <div class="FilterContainer" style="margin-top: -25px; margin-left: 45px;" v-if="FilterYear[0] === FilterYear[1]">
                <div class="FilterTitle">月</div>
                <div>
                    <VueSlider v-model="FilterMonth" :min="1" :max="12" marks @drag-end="OnFilterMonthChange" />
                </div>
            </div>
        </div>
    </div>
    <div id="KeikakumeisaiData">
        <div id="Keikakumeisai_ProductTotal" class="Keikakumeisai_ProductEntry" style="padding-bottom: 30px;"  @click="()=>{ this.IsTotalDataContainerUnfold = !this.IsTotalDataContainerUnfold; }">
            <div class="Keikakumeisai_ProductBasicInfo">
                <div class="Keikakumeisai_IconUnfoldContainer"></div>
                <div class="Keikakumeisai_ProductName"></div>
                <div class="Keikakumeisai_ProductBasic"></div>
                <div class="Keikakumeisai_ProductBasic"><div>受注数</div> <div :class="{NegativeCurrency: this.TotalOrders < 0}">{{ this.$FormatNumber(this.TotalOrders) }}</div></div>
                <div class="Keikakumeisai_ProductBasic"><div>売上</div> <div :class="{NegativeCurrency: this.TotalSales < 0}">{{ this.$FormatCurrency(this.TotalSales) }}</div></div>
                <div class="Keikakumeisai_ProductBasic"><div>利益</div> <div :class="{NegativeCurrency: this.TotalProfit < 0}">{{ this.$FormatCurrency(this.TotalProfit) }}</div></div>
            </div>
            <div class="Keikakumeisai_ProductBasicInfo">
                <div class="Keikakumeisai_IconUnfoldContainer"><img src="@/assets/Icon_Unfold.svg" :class="{'Keikakumeisa_IconUnfolded': IsTotalDataContainerUnfold}" /></div>
                <div class="Keikakumeisai_ProductName">年間の合計</div>
                <div class="Keikakumeisai_ProductBasic"><div style="font-weight: bold;" title="100%">原価合計</div> <div>{{ this.$FormatCurrency(this.TotalCost) }}</div></div>
                <div class="Keikakumeisai_ProductBasic"><div :title="this.$FormatNumber(this.TotalCostIncludingExpenses * 100 / this.TotalCost) + '%'">原価算入経費</div> <div :class="{NegativeCurrency: this.TotalCostIncludingExpenses < 0}">{{ this.$FormatNumber(this.TotalCostIncludingExpenses) }}</div></div>
                <div class="Keikakumeisai_ProductBasic"><div :title="this.$FormatNumber(this.TotalNonCostExpenses * 100 / this.TotalCost) + '%'">原価算入外経費</div> <div :class="{NegativeCurrency: this.TotalNonCostExpenses < 0}">{{ this.$FormatNumber(this.TotalNonCostExpenses) }}</div></div>
                <div class="Keikakumeisai_ProductBasic"><div :title="this.$FormatNumber(this.TotalOtherCostExpenses * 100 / this.TotalCost) + '%'">共通経費</div> <div :class="{NegativeCurrency: this.TotalOtherCostExpenses < 0}">{{ this.$FormatNumber(this.TotalOtherCostExpenses) }}</div></div>
            </div>
            <div :class="{'Keikakumeisai_DataContainer': true, Keikakumeisai_TotalDataContainer_Open: IsTotalDataContainerUnfold}">
                <div class="Keikakumeisai_TotalCostContainer">
                    <div class="Keikakumeisai_TotalCostGroupContainer">
                        <div class="Keikakumeisai_TotalCostGroupContainerUnfold" @click="(event)=>{event.stopPropagation(); this.IsTotalCostIncludingExpensesUnfold = !this.IsTotalCostIncludingExpensesUnfold; }">
                            <div class="Keikakumeisai_IconUnfoldContainer"><img src="@/assets/Icon_Unfold.svg" :class="{'Keikakumeisa_IconUnfolded': IsTotalCostIncludingExpensesUnfold}" /></div>
                            <div class="Keikakumeisai_ExpenseType Keikakumeisai_CostIncluding" :title="this.$FormatNumber(this.TotalCostIncludingExpenses * 100 / this.TotalCost) + '%'">原価算入経費</div>
                        </div>
                        <div :class="{'Keikakumeisai_HanbaisakiDataContainer': true, Keikakumeisai_TotalDataContainer_Open: IsTotalCostIncludingExpensesUnfold}">
                            <div class="Keikakumeisai_DetailsContainer">
                                <div :class="{'Keikakumeisai_Details':true, 'Keikakumeisai_HanbaisakiBasicInfo':true, GrayUnderline: IsTotalPurchaseCostUnfold} " @click="(event)=>{event.stopPropagation(); this.IsTotalPurchaseCostUnfold = !this.IsTotalPurchaseCostUnfold; console.log('unfold total purchase expenses', this.IsTotalPurchaseCostUnfold); }">
                                    <div class="Keikakumeisai_IconUnfoldContainer"><img src="@/assets/Icon_Unfold.svg" :class="{'Keikakumeisa_IconUnfolded': IsTotalPurchaseCostUnfold}" /></div>
                                    <div :class="{Keikakumeisai_TotalCostGroupHead: true, GrayUnderlineBright: !IsTotalPurchaseCostUnfold}" :title="this.$FormatNumber(this.TotalPurchaseAmountGroup * 100 / this.TotalCostIncludingExpenses) + '%'">仕入額</div>
                                    <div :class="{Keikakumeisai_TotalCostGroupHeadValue: true, GrayUnderlineBright: !IsTotalPurchaseCostUnfold}" :title="this.$FormatNumber(this.TotalPurchaseAmountGroup * 100 / this.TotalCostIncludingExpenses) + '%'">{{ this.$FormatCurrency(this.TotalPurchaseAmountGroup) }}</div>
                                </div>
                                <div :class="{'Keikakumeisai_Details':true, 'Keikakumeisai_HanbaisakiDataContainer': true, Keikakumeisai_TotalDataContainer_Open: IsTotalPurchaseCostUnfold}" @click="(event)=>{event.stopPropagation();}">
                                    <div class="Keikakumeisai_TotalCostGroup">
                                        <div class="Keikakumeisai_TotalCostItem Keikakumeisai_TotalCostSubHead GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalPurchaseAmount * 100 / this.TotalPurchaseAmountGroup) + '%'">仕入額</div><div class="Keikakumeisai_TotalCostValue Keikakumeisai_TotalCostSubValue">{{ this.$FormatCurrency(this.TotalPurchaseAmount) }}</div></div>
                                        <div class="Keikakumeisai_TotalCostItem Keikakumeisai_TotalCostSubHead GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalSamplePurchaseAmount * 100 / this.TotalPurchaseAmountGroup) + '%'">見本仕入額</div><div class="Keikakumeisai_TotalCostValue Keikakumeisai_TotalCostSubValue">{{ this.$FormatCurrency(this.TotalSamplePurchaseAmount) }}</div></div>
                                    </div>
                                </div>
                                <div class="Keikakumeisai_Details Keikakumeisai_TotalCostGroup" style="margin-left: 44px;" @click="(event)=>{event.stopPropagation();}">
                                    <div class="Keikakumeisai_TotalCostItem GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalCustomsCost * 100 / this.TotalCostIncludingExpenses) + '%'">関税</div> <div class="Keikakumeisai_TotalCostValue">{{ this.$FormatCurrency(this.TotalCustomsCost) }}</div></div>
                                    <div class="Keikakumeisai_TotalCostItem GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalShippingExpenses * 100 / this.TotalCostIncludingExpenses) + '%'">船積経費</div> <div class="Keikakumeisai_TotalCostValue">{{ this.$FormatCurrency(this.TotalShippingExpenses) }}</div></div>
                                    <div class="Keikakumeisai_TotalCostItem GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalHeadOfficeExpenses * 100 / this.TotalCostIncludingExpenses) + '%'">本社費</div> <div class="Keikakumeisai_TotalCostValue">{{ this.$FormatCurrency(this.TotalHeadOfficeExpenses) }}</div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="Keikakumeisai_TotalCostGroupContainer">
                        <div class="Keikakumeisai_TotalCostGroupContainerUnfold" @click="(event)=>{event.stopPropagation(); this.IsTotalNonCostExpensesUnfold = !this.IsTotalNonCostExpensesUnfold; }">
                            <div class="Keikakumeisai_IconUnfoldContainer"><img src="@/assets/Icon_Unfold.svg" :class="{'Keikakumeisa_IconUnfolded': IsTotalNonCostExpensesUnfold}" /></div>
                            <div class="Keikakumeisai_ExpenseType Keikakumeisai_NonCost" :title="this.$FormatNumber(this.TotalNonCostExpenses * 100 / this.TotalCost) + '%'">原価算入外経費</div>
                        </div>
                        <div :class="{'Keikakumeisai_HanbaisakiDataContainer': true, Keikakumeisai_TotalDataContainer_Open: IsTotalNonCostExpensesUnfold}">
                            <div class="Keikakumeisai_DetailsContainer">
                                <div class="Keikakumeisai_Details Keikakumeisai_TotalCostGroup" style="margin-left: 44px;" @click="(event)=>{event.stopPropagation();}">
                                    <div class="Keikakumeisai_TotalCostItem GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalPrototypeCost * 100 / this.TotalNonCostExpenses) + '%'">原型</div> <div class="Keikakumeisai_TotalCostValue">{{ this.$FormatCurrency(this.TotalPrototypeCost) }}</div></div>
                                    <div class="Keikakumeisai_TotalCostItem GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalMoldCost * 100 / this.TotalNonCostExpenses) + '%'">金型</div> <div class="Keikakumeisai_TotalCostValue">{{ this.$FormatCurrency(this.TotalMoldCost) }}</div></div>
                                    <div class="Keikakumeisai_TotalCostItem GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalCopyrightFees * 100 / this.TotalNonCostExpenses) + '%'">著作権料</div> <div class="Keikakumeisai_TotalCostValue">{{ this.$FormatCurrency(this.TotalCopyrightFees) }}</div></div>
                                </div>
                                <div :class="{'Keikakumeisai_Details':true, 'Keikakumeisai_HanbaisakiBasicInfo':true, GrayUnderline: IsTotalSalesCommissionUnfold} " @click="(event)=>{event.stopPropagation(); this.IsTotalSalesCommissionUnfold = !this.IsTotalSalesCommissionUnfold; }">
                                    <div class="Keikakumeisai_IconUnfoldContainer"><img src="@/assets/Icon_Unfold.svg" :class="{'Keikakumeisa_IconUnfolded': IsTotalSalesCommissionUnfold}" /></div>
                                    <div :class="{Keikakumeisai_TotalCostGroupHead: true, GrayUnderlineBright: !IsTotalSalesCommissionUnfold}" :title="this.$FormatNumber(this.TotalSalesCommissionGroup * 100 / this.TotalNonCostExpenses) + '%'">売上ｺﾐｯｼｮﾝ</div>
                                    <div :class="{Keikakumeisai_TotalCostGroupHeadValue: true, GrayUnderlineBright: !IsTotalSalesCommissionUnfold}" :title="this.$FormatNumber(this.TotalSalesCommissionGroup * 100 / this.TotalNonCostExpenses) + '%'">{{ this.$FormatCurrency(this.TotalSalesCommissionGroup) }}</div>
                                </div>
                                <div :class="{'Keikakumeisai_Details':true, 'Keikakumeisai_HanbaisakiDataContainer': true, Keikakumeisai_TotalDataContainer_Open: IsTotalSalesCommissionUnfold}" @click="(event)=>{event.stopPropagation();}">
                                    <div class="Keikakumeisai_TotalCostGroup">
                                        <div class="Keikakumeisai_TotalCostItem Keikakumeisai_TotalCostSubHead GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalSculptorCost * 100 / this.TotalSalesCommissionGroup) + '%'">原型師</div><div class="Keikakumeisai_TotalCostValue Keikakumeisai_TotalCostSubValue">{{ this.$FormatCurrency(this.TotalSculptorCost) }}</div></div>
                                        <div class="Keikakumeisai_TotalCostItem Keikakumeisai_TotalCostSubHead GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalSalesCommission_PB * 100 / this.TotalSalesCommissionGroup) + '%'">PB</div><div class="Keikakumeisai_TotalCostValue Keikakumeisai_TotalCostSubValue">{{ this.$FormatCurrency(this.TotalSalesCommission_PB) }}</div></div>
                                    </div>
                                </div>
                                <div :class="{'Keikakumeisai_Details':true, 'Keikakumeisai_HanbaisakiBasicInfo':true, GrayUnderline: IsTotalECExpensesUnfold} " @click="(event)=>{event.stopPropagation(); this.IsTotalECExpensesUnfold = !this.IsTotalECExpensesUnfold; }">
                                    <div class="Keikakumeisai_IconUnfoldContainer"><img src="@/assets/Icon_Unfold.svg" :class="{'Keikakumeisa_IconUnfolded': IsTotalECExpensesUnfold}" /></div>
                                    <div :class="{Keikakumeisai_TotalCostGroupHead: true, GrayUnderlineBright: !IsTotalECExpensesUnfold}" :title="this.$FormatNumber(this.TotalECFees * 100 / this.TotalNonCostExpenses) + '%'">EC決済手数料</div>
                                    <div :class="{Keikakumeisai_TotalCostGroupHeadValue: true, GrayUnderlineBright: !IsTotalECExpensesUnfold}" :title="this.$FormatNumber(this.TotalECFees * 100 / this.TotalNonCostExpenses) + '%'">{{ this.$FormatCurrency(this.TotalECFees) }}</div>
                                </div>
                                <div :class="{'Keikakumeisai_Details':true, 'Keikakumeisai_HanbaisakiDataContainer': true, Keikakumeisai_TotalDataContainer_Open: IsTotalECExpensesUnfold}" @click="(event)=>{event.stopPropagation();}">
                                    <div class="Keikakumeisai_TotalCostGroup">
                                        <div class="Keikakumeisai_TotalCostItem Keikakumeisai_TotalCostSubHead GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalECPaymentFees * 100 / this.TotalECFees) + '%'">IT/PB EC決済手数料</div><div class="Keikakumeisai_TotalCostValue Keikakumeisai_TotalCostSubValue">{{ this.$FormatCurrency(this.TotalECPaymentFees) }}</div></div>
                                        <div class="Keikakumeisai_TotalCostItem Keikakumeisai_TotalCostSubHead GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalCardFees * 100 / this.TotalECFees) + '%'">ｶｰﾄﾞ決済手数料</div><div class="Keikakumeisai_TotalCostValue Keikakumeisai_TotalCostSubValue">{{ this.$FormatCurrency(this.TotalCardFees) }}</div></div>
                                    </div>
                                </div>
                                <div :class="{'Keikakumeisai_Details':true, 'Keikakumeisai_HanbaisakiBasicInfo':true, GrayUnderline: IsTotalShippingFeesUnfold} " @click="(event)=>{event.stopPropagation(); this.IsTotalShippingFeesUnfold = !this.IsTotalShippingFeesUnfold; }">
                                    <div class="Keikakumeisai_IconUnfoldContainer"><img src="@/assets/Icon_Unfold.svg" :class="{'Keikakumeisa_IconUnfolded': IsTotalShippingFeesUnfold}" /></div>
                                    <div :class="{Keikakumeisai_TotalCostGroupHead: true, GrayUnderlineBright: !IsTotalShippingFeesUnfold}" :title="this.$FormatNumber(this.TotalShippingFeesGroup * 100 / this.TotalNonCostExpenses) + '%'">出荷手数料</div>
                                    <div :class="{Keikakumeisai_TotalCostGroupHeadValue: true, GrayUnderlineBright: !IsTotalShippingFeesUnfold}" :title="this.$FormatNumber(this.TotalShippingFeesGroup * 100 / this.TotalNonCostExpenses) + '%'">{{ this.$FormatCurrency(this.TotalShippingFeesGroup) }}</div>
                                </div>
                                <div :class="{'Keikakumeisai_Details':true, 'Keikakumeisai_HanbaisakiDataContainer': true, Keikakumeisai_TotalDataContainer_Open: IsTotalShippingFeesUnfold}" @click="(event)=>{event.stopPropagation();}">
                                    <div class="Keikakumeisai_TotalCostGroup">
                                        <div class="Keikakumeisai_TotalCostItem Keikakumeisai_TotalCostSubHead GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalShipping_Warehouse * 100 / this.TotalShippingFeesGroup) + '%'">倉庫</div><div class="Keikakumeisai_TotalCostValue Keikakumeisai_TotalCostSubValue">{{ this.$FormatCurrency(this.TotalShipping_Warehouse) }}</div></div>
                                        <div class="Keikakumeisai_TotalCostItem Keikakumeisai_TotalCostSubHead GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalShipping_PB * 100 / this.TotalShippingFeesGroup) + '%'">PB</div><div class="Keikakumeisai_TotalCostValue Keikakumeisai_TotalCostSubValue">{{ this.$FormatCurrency(this.TotalShipping_PB) }}</div></div>
                                    </div>
                                </div>
                                <div :class="{'Keikakumeisai_Details':true, 'Keikakumeisai_HanbaisakiBasicInfo':true, GrayUnderline: IsTotalShippingExpensesUnfold} " @click="(event)=>{event.stopPropagation(); this.IsTotalShippingExpensesUnfold = !this.IsTotalShippingExpensesUnfold; }">
                                    <div class="Keikakumeisai_IconUnfoldContainer"><img src="@/assets/Icon_Unfold.svg" :class="{'Keikakumeisa_IconUnfolded': IsTotalShippingExpensesUnfold}" /></div>
                                    <div :class="{Keikakumeisai_TotalCostGroupHead: true, GrayUnderlineBright: !IsTotalShippingExpensesUnfold}" :title="this.$FormatNumber(this.TotalShippingHandlingGroup * 100 / this.TotalNonCostExpenses) + '%'">出荷運賃</div>
                                    <div :class="{Keikakumeisai_TotalCostGroupHeadValue: true, GrayUnderlineBright: !IsTotalShippingExpensesUnfold}" :title="this.$FormatNumber(this.TotalShippingHandlingGroup * 100 / this.TotalNonCostExpenses) + '%'">{{ this.$FormatCurrency(this.TotalShippingHandlingGroup) }}</div>
                                </div>
                                <div :class="{'Keikakumeisai_Details':true, 'Keikakumeisai_HanbaisakiDataContainer': true, Keikakumeisai_TotalDataContainer_Open: IsTotalShippingExpensesUnfold}" @click="(event)=>{event.stopPropagation();}">
                                    <div class="Keikakumeisai_TotalCostGroup">
                                        <div class="Keikakumeisai_TotalCostItem Keikakumeisai_TotalCostSubHead GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalShippingHandling_Warehouse * 100 / this.TotalShippingHandlingGroup) + '%'">倉庫</div><div class="Keikakumeisai_TotalCostValue Keikakumeisai_TotalCostSubValue">{{ this.$FormatCurrency(this.TotalShippingHandling_Warehouse) }}</div></div>
                                        <div class="Keikakumeisai_TotalCostItem Keikakumeisai_TotalCostSubHead GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalShippingHandling_PB * 100 / this.TotalShippingHandlingGroup) + '%'">PB</div><div class="Keikakumeisai_TotalCostValue Keikakumeisai_TotalCostSubValue">{{ this.$FormatCurrency(this.TotalShippingHandling_PB) }}</div></div>
                                    </div>
                                </div>
                                <div class="Keikakumeisai_Details Keikakumeisai_TotalCostGroup" style="margin-left: 44px;" @click="(event)=>{event.stopPropagation();}">
                                    <div class="Keikakumeisai_TotalCostItem GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalDevan * 100 / this.TotalCostIncludingExpenses) + '%'">ﾃﾞﾊﾞﾝ</div> <div class="Keikakumeisai_TotalCostValue">{{ this.$FormatCurrency(this.TotalDevan) }}</div></div>
                                    <div class="Keikakumeisai_TotalCostItem"><div :title="this.$FormatNumber(this.TotalStorageFee * 100 / this.TotalNonCostExpenses) + '%'">保管料</div> <div class="Keikakumeisai_TotalCostValue">{{ this.$FormatCurrency(this.TotalStorageFee) }}</div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="Keikakumeisai_TotalCostGroupContainer">
                        <div class="Keikakumeisai_TotalCostGroupContainerUnfold" @click="(event)=>{event.stopPropagation(); this.IsTotalOtherCostExpensesUnfold = !this.IsTotalOtherCostExpensesUnfold; }">
                            <div class="Keikakumeisai_IconUnfoldContainer"><img src="@/assets/Icon_Unfold.svg" /></div>
                            <div class="Keikakumeisai_ExpenseType Keikakumeisai_OtherCost" :title="this.$FormatNumber(this.TotalOtherCostExpenses * 100 / this.TotalCost) + '%'">共通経費</div>
                        </div>
                        <div :class="{'Keikakumeisai_HanbaisakiDataContainer': true, Keikakumeisai_TotalDataContainer_Open: IsTotalOtherCostExpensesUnfold}">
                            <div class="Keikakumeisai_DetailsContainer">
                                <div class="Keikakumeisai_Details Keikakumeisai_TotalCostGroup" style="margin-left: 44px;" @click="(event)=>{event.stopPropagation();}">
                                    <div class="Keikakumeisai_TotalCostItem GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalWAX * 100 / this.TotalOtherCostExpenses) + '%'">WAX</div> <div class="Keikakumeisai_TotalCostValue">{{ this.$FormatCurrency(this.TotalWAX) }}</div></div>
                                    <div class="Keikakumeisai_TotalCostItem GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalPackageDesign * 100 / this.TotalOtherCostExpenses) + '%'">PKGﾃﾞｻﾞｲﾝ</div> <div class="Keikakumeisai_TotalCostValue">{{ this.$FormatCurrency(this.TotalPackageDesign) }}</div></div>
                                    <div class="Keikakumeisai_TotalCostItem GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalAlanCommission * 100 / this.TotalOtherCostExpenses) + '%'">阿蘭さん固定ｺﾐｯｼｮﾝ</div> <div class="Keikakumeisai_TotalCostValue">{{ this.$FormatCurrency(this.TotalAlanCommission) }}</div></div>
                                    <div class="Keikakumeisai_TotalCostItem GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalProductionCommission * 100 / this.TotalOtherCostExpenses) + '%'">生産ｺﾐｯｼｮﾝ</div> <div class="Keikakumeisai_TotalCostValue">{{ this.$FormatCurrency(this.TotalProductionCommission) }}</div></div>
                                    <div class="Keikakumeisai_TotalCostItem GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalShippingPackage * 100 / this.TotalOtherCostExpenses) + '%'">出荷ｹｰｽ</div> <div class="Keikakumeisai_TotalCostValue">{{ this.$FormatCurrency(this.TotalShippingPackage) }}</div></div>
                                    <div class="Keikakumeisai_TotalCostItem GrayUnderlineBright"><div :title="this.$FormatNumber(this.TotalSampleCost * 100 / this.TotalOtherCostExpenses) + '%'">見本品費</div> <div class="Keikakumeisai_TotalCostValue">{{ this.$FormatCurrency(this.TotalSampleCost) }}</div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div id="Sorting">
                <div style="margin-left: 49px; flex: 1;"></div>
                <SortingButton style="flex: 0.5;" v-for="(entry, index) in SortingOptions" :key="index" :IsDesc="IsSortingDesc" :Label="entry.Label" :IsSorting="CurrentSortType === index" :-sorting-type="index" :-on-click="OnSorting" />
            </div>
        </div>
        <KeikakumeisaiEntry v-for="entry in Products"
            :key="entry.id"
            :-on-click-factory="(factory)=>{ this.$refs.FactoryFilter.ToggleItem(factory); }"
            :-on-click-series="(series)=>{ this.$refs.SeriesFilter.ToggleItem(series); }"
            :-on-click-brand="(brand)=>{ this.$refs.BrandFilter.ToggleItem(brand); }"
            :IsFiltered="this.IsProductFiltered(entry.productName) &&
                         this.IsFactoryFiltered(entry.factory) &&
                         this.IsSeriesFiltered(entry.series) &&
                         this.IsBrandFiltered(entry.brand)"
            :ProductInfo="entry"/>
    </div>
</template>

<script>
import GenericMultiDropdown from '@/components/GenericMultiDropdown.vue';
import moment from "moment";
// import DatePicker from "./components/DatePicker.vue";
import axios from 'axios';
import KeikakumeisaiEntry from '@/components/KeikakumeisaiEntry.vue';
import TextSearch from '@/components/TextSearch.vue';
import SortingButton from '@/components/SortingButton.vue';
import { ShowLoading } from '@/utils/FullScreenLoading';
import VueSlider from 'vue-3-slider-component';

export default{
    components:
    {
        GenericMultiDropdown,
        // DatePicker,
        KeikakumeisaiEntry,
        TextSearch,
        SortingButton,
        VueSlider,
    },
    mounted()
    {
        this.GetKeikakumeisaiData();
    },
    methods:
    {
        OnSorting(sortingType)
        {
            if (this.CurrentSortType !== sortingType)
            {
                this.IsSortingDesc = true;
            }
            else
            {
                this.IsSortingDesc = !this.IsSortingDesc;
            }

            this.CurrentSortType = sortingType;
            this.SortData();
        },
        async SortData()
        {
            const sortFunc = this.IsSortingDesc ? this.SortingOptions[this.CurrentSortType].Desc : this.SortingOptions[this.CurrentSortType].Asc;
            this.Products.sort(sortFunc);
            console.log('products sorted', this.Products);
        },
        async GetKeikakumeisaiData()
        {
            ShowLoading(true, 'ローディング中');
            this.Products = [];

            const startDate = moment();
            startDate.year(this.FilterYear[0]);
            startDate.month(this.FilterYear[0] === this.FilterYear[1] ? this.FilterMonth[0] : 1);
            startDate.date(0);
            startDate.hour(0);
            startDate.minute(0);
            startDate.second(0);

            const endDate = moment();
            endDate.year(this.FilterYear[1]);
            endDate.month(this.FilterYear[0] === this.FilterYear[1] ? this.FilterMonth[1] : 12);
            endDate.date(0);
            endDate.hour(0);
            endDate.minute(0);
            endDate.second(0);

            let data = {
                SessionToken: this.$GetToken(),
                // StartDate: this.SelectedFilterDate[0].format(`YYYY-MM-DD ${process.env.VUE_APP_TIMEZONE_ADD_HOURS}:mm:ss`),
                // EndDate: this.SelectedFilterDate[1].format(`YYYY-MM-DD ${process.env.VUE_APP_TIMEZONE_ADD_HOURS}:mm:ss`)
                StartDate: startDate.format(`YYYY-MM-DD ${process.env.VUE_APP_TIMEZONE_ADD_HOURS}:mm:ss`),
                EndDate: endDate.format(`YYYY-MM-DD ${process.env.VUE_APP_TIMEZONE_ADD_HOURS}:mm:ss`)
            };

            const keikakumeisaiData = await axios.post(process.env.VUE_APP_BACKEND_URL + 'keikakumeisai', data)
            .then(result => {
                ShowLoading(false);
                return result.data;
            })
            .catch(error => {
                ShowLoading(false);
                if (error.response.status != 500)
                {
                    this.$HandleBadRequest(error.response.status, error.response.data);
                }
                console.log('keikakumeisai request error', error);
                return null;
            });

            console.log('keikakumeisai result', keikakumeisaiData);

            const minDate = keikakumeisaiData.dateRange.length > 0 ? new Date(keikakumeisaiData.dateRange[0].min_date) : new Date();
            const maxDate = keikakumeisaiData.dateRange.length > 0 ? new Date(keikakumeisaiData.dateRange[0].max_date) : new Date();

            this.MinFilterYear = minDate.getFullYear();
            this.MaxFilterYear = maxDate.getFullYear();

            this.FactoryOptions = [];
            for (let i = 0; i < keikakumeisaiData.factories.length; i++)
            {
                this.FactoryOptions.push({ label: keikakumeisaiData.factories[i].name, value: keikakumeisaiData.factories[i].id });
            }

            this.SeriesOptions = [];
            for (let i = 0; i < keikakumeisaiData.series.length; i++)
            {
                this.SeriesOptions.push({ label: keikakumeisaiData.series[i].name, value: keikakumeisaiData.series[i].id });
            }

            this.BrandOptions = [];
            for (let i = 0; i < keikakumeisaiData.brands.length; i++)
            {
                this.BrandOptions.push({ label: keikakumeisaiData.brands[i].name, value: keikakumeisaiData.brands[i].id });
            }
            
            // Merge productData with products
            this.Products = keikakumeisaiData.products;

            for (let i = 0; i < this.Products.length; i++)
            {
                const product = this.Products[i];
                product.Data = [];
                product.TotalSales = 0;
                product.TotalProfit = 0;
                product.TotalAmount = 0;
                product.ReleaseCount = 1;
                for (let j = 0; j < keikakumeisaiData.productData.length; j++)
                {
                    const data = keikakumeisaiData.productData[j];
                    // if (data.productID === product.id)
                    if (data.styleNumber === product.productCode)
                    {
                        // this.Products[i].Data.push(data);
                        product.Data.push(data);

                        product.TotalSales += data.sales;
                        product.TotalProfit += data.profit;
                        product.TotalAmount += data.amount;
                        product.ReleaseCount = Math.max(product.ReleaseCount, data.release_number);
                    }
                }
            }

            // Merge products but seperate data by stylenumber
            const newProductArray = [];
            for (let i = 0; i < this.Products.length; i++)
            {
                const oP = this.Products[i];
                let product = null;

                // Look if we already have added the product
                for (let j = 0; j < newProductArray.length; j++)
                {
                    if (newProductArray[j].productName === oP.productName)
                    {
                        product = newProductArray[j];
                        break;
                    }
                }

                if (product === null)
                {
                    product = {
                        productName: oP.productName,
                        brand: oP.brand,
                        factory: oP.factory,
                        series: oP.series,
                        styleNumbers: [],
                        TotalAmount: 0,
                        TotalProfit: 0,
                        TotalSales: 0,
                        ReleaseCount: 1
                    };

                    newProductArray.push(product);
                }

                product.TotalSales += oP.TotalSales;
                product.TotalProfit += oP.TotalProfit;
                product.TotalAmount += oP.TotalAmount;
                product.ReleaseCount = Math.max(product.ReleaseCount, oP.ReleaseCount);

                product.styleNumbers.push({
                    JAN: oP.JAN,
                    Data: oP.Data,
                    productCode: oP.productCode,
                    serialNumber: oP.serialNumber,
                });
            }

            this.Products = newProductArray;
            console.log('Products', this.Products);
            
            this.UpdateView();
        },
        async UpdateView()
        {
            {
                this.TotalOrders = 0;
                this.TotalSales = 0;
                this.TotalProfit = 0;
                this.TotalCost = 0;
                this.TotalCostIncludingExpenses = 0;
                this.TotalNonCostExpenses = 0;
                this.TotalOtherCostExpenses = 0;
                this.TotalPurchaseAmountGroup = 0;
                this.TotalPurchaseAmount = 0;
                this.TotalSamplePurchaseAmount = 0;
                this.TotalPrototypeCost = 0;
                this.TotalMoldCost = 0;
                this.TotalCopyrightFees = 0;
                this.TotalCustomsCost = 0;
                this.TotalSalesCommissionGroup = 0;
                this.TotalSculptorCost = 0;
                this.TotalSalesCommission_PB = 0;
                this.TotalECPaymentFees = 0;
                this.TotalECFees = 0;
                this.TotalCardFees = 0;
                this.TotalShippingFeesGroup = 0;
                this.TotalShipping_Warehouse = 0;
                this.TotalShipping_PB = 0;
                this.TotalShippingHandlingGroup = 0;
                this.TotalShippingHandling_Warehouse = 0;
                this.TotalShippingHandling_PB = 0;
                this.TotalShippingExpenses = 0;
                this.TotalDevan = 0;
                this.TotalStorageFee = 0;
                this.TotalHeadOfficeExpenses = 0;
                this.TotalWAX = 0;
                this.TotalPackageDesign = 0;
                this.TotalAlanCommission = 0;
                this.TotalProductionCommission = 0;
                this.TotalShippingPackage = 0;
            }

            for (let i = 0; i < this.Products.length; i++)
            {
                const product = this.Products[i];
                
                if (this.IsFactoryFiltered(product.factory) === false ||
                    this.IsSeriesFiltered(product.series) === false ||
                    this.IsBrandFiltered(product.brand) === false ||
                    this.IsProductFiltered(product.productName) === false)
                {
                    continue;
                }

                for (let j = 0; j < product.styleNumbers.length; j++)
                {
                    const styleNumber = product.styleNumbers[j];
                    for (let k = 0; k < styleNumber.Data.length; k++)
                    {
                        const data = styleNumber.Data[k];
                     
                        this.TotalOrders += data.amount;
                        this.TotalSales += data.sales;
                        this.TotalProfit += data.profit;

                        // Purple TTL (Cost including expenses)
                        this.TotalCostIncludingExpenses += data.purchaseAmount;
                        this.TotalCostIncludingExpenses += data.samplePurchaseAmount;
                        this.TotalCostIncludingExpenses += data.customs;
                        this.TotalCostIncludingExpenses += data.shippingExpenses;
                        this.TotalCostIncludingExpenses += data.headOfficeExpenses;

                        // Purple cost (Cost including expenses)
                        this.TotalPurchaseAmountGroup += data.purchaseAmount;
                        this.TotalPurchaseAmountGroup += data.samplePurchaseAmount;
                        this.TotalPurchaseAmount += data.purchaseAmount;
                        this.TotalSamplePurchaseAmount += data.samplePurchaseAmount;
                        this.TotalCustomsCost += data.customs;
                        this.TotalShippingExpenses += data.shippingExpenses;
                        this.TotalHeadOfficeExpenses += data.headOfficeExpenses;

                        // Orange TTL (Cost excluding expenses)
                        this.TotalNonCostExpenses += data.prototypeCost;
                        this.TotalNonCostExpenses += data.moldCost;
                        this.TotalNonCostExpenses += data.copyrightFees;
                        this.TotalNonCostExpenses += data.commission_sculptor;
                        this.TotalNonCostExpenses += data.commission_pb;
                        this.TotalNonCostExpenses += data.fee_it_pb_ec;
                        this.TotalNonCostExpenses += data.fee_cardPayment;
                        this.TotalNonCostExpenses += data.shipping_warehouse;
                        this.TotalNonCostExpenses += data.shipping_pb;
                        this.TotalNonCostExpenses += data.handling_warehouse;
                        this.TotalNonCostExpenses += data.handling_pb;
                        this.TotalNonCostExpenses += data.devanning;
                        this.TotalNonCostExpenses += data.fee_storage;
                        
                        // Orange cost (Cost excluding expenses)
                        this.TotalPrototypeCost += data.prototypeCost;
                        this.TotalMoldCost += data.moldCost;
                        this.TotalCopyrightFees += data.copyrightFees;
                        this.TotalSalesCommissionGroup += data.commission_sculptor;
                        this.TotalSalesCommissionGroup += data.commission_pb;
                        this.TotalSculptorCost += data.commission_sculptor;
                        this.TotalSalesCommission_PB += data.commission_pb;
                        this.TotalECFees += data.fee_it_pb_ec;
                        this.TotalECFees += data.fee_cardPayment;
                        this.TotalECPaymentFees += data.fee_it_pb_ec;
                        this.TotalCardFees += data.fee_cardPayment;
                        this.TotalShippingFeesGroup += data.shipping_warehouse;
                        this.TotalShippingFeesGroup += data.shipping_pb;
                        this.TotalShipping_Warehouse += data.shipping_warehouse;
                        this.TotalShipping_PB += data.shipping_pb;
                        this.TotalShippingHandlingGroup += data.handling_warehouse;
                        this.TotalShippingHandlingGroup += data.handling_pb;
                        this.TotalShippingHandling_Warehouse += data.handling_warehouse;
                        this.TotalShippingHandling_PB += data.handling_pb;
                        this.TotalDevan += data.devanning;
                        this.TotalStorageFee += data.fee_storage;

                        // White TTL (other expenses)
                        this.TotalOtherCostExpenses += data.WAX;
                        this.TotalOtherCostExpenses += data.packageDesign;
                        this.TotalOtherCostExpenses += data.commission_alan;
                        this.TotalOtherCostExpenses += data.commission_production;
                        this.TotalOtherCostExpenses += data.shippingCase;
                        this.TotalOtherCostExpenses += data.samplesCost < 0 ? -data.samplesCost : data.samplesCost;

                        // White cost (other expenses)
                        this.TotalWAX += data.WAX;
                        this.TotalPackageDesign += data.packageDesign;
                        this.TotalAlanCommission += data.commission_alan;
                        this.TotalProductionCommission += data.commission_production;
                        this.TotalShippingPackage += data.shippingCase;
                        this.TotalSampleCost += data.samplesCost < 0 ? -data.samplesCost : data.samplesCost;
                    }
                }
            }

            this.TotalCost += this.TotalCostIncludingExpenses;
            this.TotalCost += this.TotalNonCostExpenses;
            this.TotalCost += this.TotalOtherCostExpenses;
        },
        ShowCalendar()
        {
            this.show.calendar = !this.show.calendar;

            if (this.show.calendar === true)
            {
                const closer = document.createElement('div');
                closer.id = 'datecloser';
                closer.style.position = 'absolute';
                closer.style.top = '0px';
                closer.style.left = '0px';
                closer.style.width = '100%';
                closer.style.height = '100%';
                document.body.append(closer);
    
                closer.onclick = ()=>{
                    this.ShowCalendar();
                    closer.remove();
                };
            }
            else
            {
                let closer = document.getElementById('datecloser');
                if (closer !== null)
                {
                    closer.remove();
                }
            }
        },
        OnFilterYearChange()
        {
            this.GetKeikakumeisaiData();
        },
        OnFilterMonthChange()
        {
            this.GetKeikakumeisaiData();
        },
        UpdatedFilterDate(updatedDate)
        {
            this.SelectedFilterDate = updatedDate;
            console.log('filter date updated', this.SelectedFilterDate);

            let target = document.getElementById('SalesHead');
            if (target !== null)
            {
                target.replaceChildren();
            }
            target = document.getElementById('SalesContainerHelper');
            if (target !== null)
            {
                target.replaceChildren();
            }

            this.GetKeikakumeisaiData();
            this.ShowCalendar();
        },
        OnSearchChange(newSearch)
        {
            this.SearchString = newSearch;
            this.UpdateView();
        },
        OnFactoryChange(newFactoryFilter)
        {
            this.SelectedFactories = newFactoryFilter;
            this.UpdateView();
        },
        OnSeriesChange(newSeriesFilter)
        {
            this.SelectedSeries = newSeriesFilter;
            this.UpdateView();
        },
        OnBrandChange(newBrandFilter)
        {
            this.SelectedBrands = newBrandFilter;
            this.UpdateView();
        },
        IsFactoryFiltered(factory)
        {
            if (this.SelectedFactories === null ||
                this.SelectedFactories === undefined ||
                this.SelectedFactories.length === 0)
            {
                return true;
            }

            for (let i = 0; i < this.SelectedFactories.length; i++)
            {
                if (this.SelectedFactories[i].label === factory)
                {
                    return true;
                }
            }

            return false;
        },
        IsSeriesFiltered(series)
        {
            if (this.SelectedSeries === null ||
                this.SelectedSeries === undefined ||
                this.SelectedSeries.length === 0)
            {
                return true;
            }

            console.log(`Check if series ${series} is filtered. Filter count:`, this.SelectedSeries.length);
            for (let i = 0; i < this.SelectedSeries.length; i++)
            {
                console.log('Is series filtered: ' + series , this.SelectedSeries[i].label);
                if (this.SelectedSeries[i].label === series)
                {
                    return true;
                }
            }

            return false;
        },
        IsBrandFiltered(brand)
        {
            if (this.SelectedBrands === null ||
                this.SelectedBrands === undefined ||
                this.SelectedBrands.length === 0)
            {
                return true;
            }

            for (let i = 0; i < this.SelectedBrands.length; i++)
            {
                if (this.SelectedBrands[i].label === brand)
                {
                    return true;
                }
            }

            return false;
        },
        IsProductFiltered(productName)
        {
            if (this.SearchString === '' ||
                this.SearchString === null ||
                this.SearchString === undefined)
            {
                return true;
            }

            return productName.toLowerCase().includes(this.SearchString.toLowerCase());
        }
    },
    data()
    {
        return {
            FilterYear: [new Date().getFullYear(), new Date().getFullYear()],
            FilterMonth: [1,12],
            MinFilterYear: new Date().getFullYear(),
            MaxFilterYear: new Date().getFullYear(),
            Products: [],
            show:{
                calendar: false,
            },
            todayDt: moment(),
            firstDt: moment('2019-01-01'),
            SelectedFilterDate: [
                // moment().subtract(1, 'month').startOf('month'),
                moment().startOf('year'),
                moment().endOf("year")
            ],
            FactoryOptions: [],
            SeriesOptions: [],
            BrandOptions: [],
            SelectedFactories: [],
            SelectedSeries: [],
            SelectedBrands: [],
            SearchString: '',
            MinYear: 9999,
            MaxYear: 1900,
            TotalOrders: 0,
            TotalSales: 0,
            TotalProfit: 0,
            TotalCost: 0,
            // Purple | 原価算入経費
            TotalCostIncludingExpenses: 0,
            // Orange | 原価算入外経費
            TotalNonCostExpenses: 0,
            // White (total cost of white expenses)
            TotalOtherCostExpenses: 0,
            TotalPurchaseAmountGroup: 0,
            TotalPurchaseAmount: 0,
            TotalSamplePurchaseAmount: 0,
            TotalPrototypeCost: 0,
            TotalMoldCost: 0,
            TotalCopyrightFees: 0,
            TotalCustomsCost: 0,
            // Group for sculptor and commission pb
            TotalSalesCommissionGroup: 0,
            TotalSculptorCost: 0,
            TotalSalesCommission_PB: 0,
            TotalECPaymentFees: 0,
            TotalECFees: 0,
            TotalCardFees: 0,
            TotalShippingFeesGroup: 0,
            TotalShipping_Warehouse: 0,
            TotalShipping_PB: 0,
            TotalShippingHandlingGroup: 0,
            TotalShippingHandling_Warehouse: 0,
            TotalShippingHandling_PB: 0,
            TotalShippingExpenses: 0,
            TotalDevan: 0,
            TotalStorageFee: 0,
            TotalHeadOfficeExpenses: 0,
            TotalWAX: 0,
            TotalPackageDesign: 0,
            TotalAlanCommission: 0,
            TotalProductionCommission: 0,
            TotalShippingPackage: 0,
            TotalSampleCost: 0,
            IsTotalDataContainerUnfold: false,
            IsTotalCostIncludingExpensesUnfold: false,
            IsTotalPurchaseCostUnfold: false,
            IsTotalNonCostExpensesUnfold: false,
            IsTotalSalesCommissionUnfold: false,
            IsTotalECExpensesUnfold: false,
            IsTotalShippingFeesUnfold: false,
            IsTotalShippingExpensesUnfold: false,
            IsTotalOtherCostExpensesUnfold: false,
            CurrentSortType: -1,
            IsSortingDesc: false,
            SortingOptions: [
                {
                    Label: '出荷時期',
                    Asc: function(a,b){ return a.ReleaseCount-b.ReleaseCount; },
                    Desc: function(a,b){ return b.ReleaseCount-a.ReleaseCount; },
                },
                {
                    Label: '受注数',
                    Asc: function(a,b){ return a.TotalAmount-b.TotalAmount; },
                    Desc: function(a,b){ return b.TotalAmount-a.TotalAmount; },
                },
                {
                    Label: '売上',
                    Asc: function(a,b){ return a.TotalSales-b.TotalSales; },
                    Desc: function(a,b){ return b.TotalSales-a.TotalSales; },
                },
                {
                    Label: '利益',
                    Asc: function(a,b){ return a.TotalProfit-b.TotalProfit; },
                    Desc: function(a,b){ return b.TotalProfit-a.TotalProfit; },
                },
            ],
        }
    }
}
</script>

<style>
#KeikakumeisaiData
{
    padding: 5px 5px;
}

#Keikakumeisai_ProductTotal
{
    
}

#Highlight
{
    position: absolute;
    height: 69px;
    width: 100%;
    background-color: #f3f4f3;
    top: 0px;
    z-index: -1;
    transition: 0.2s;
    -moz-transition: 0.2s;
    -webkit-transition: 0.2;
}

#Settings_Header
{
    display: grid;
    box-shadow: 0px 2px 5px 1px #ccc;
    padding-left: 15px;
    padding-right: 15px;
}

.HeaderRow
{
    display: flex;
    min-height: 75px;
    height: 75px;
}

#FactoryFilterContainer
{
    align-self: center;
}

#DatePicker
{
    cursor: pointer;
}

.RoundShadowElement
{
    border: 1px solid #ddd;
    box-shadow: 3px 3px 4px 1px #eaeaea;
    border-radius: 10px;
}

.CellElement
{
    border: 1px solid #ddd;
    border-radius: 0px;
}

.RoundElement
{
    border: 1px solid #ddd;
    border-radius: 10px;
}

#FactoryFilterContainer
{
    width: 250px;
}

#SeriesFilterContainer
{
    width: 250px;
}

#BrandFilterContainer
{
    width: 250px;
}

#FilterFromContainer
{
    margin-left: 15px;
    align-self: center;
}

#FilterUntilContainer
{
    margin-left: 15px;
    align-self: center;
}

#SearchContainer
{
    align-self: center;
    margin-left: auto;
    width: 200px;
}

.FilterTitle
{
    font-size: 0.8rem;
}

.FilterElement
{
    padding: 4px 8px;
    height: 22px;
    align-content: center;
}

#Sorting
{
    display: flex;
    margin-bottom: 8px;
    padding: 10px 26px 10px 6px;
}

.ProductFactory
{
    background-color: #cee9ea;
    width: 112px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ProductReleaseDate
{
    background-color: #e1ceea;
    width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.Data
{
    margin-top: 17px;
    padding: 7px 5px;
    padding-bottom: 8px;
}

.Data input
{
    border: none;
    width: 100%;
    font-size: 1.05rem;
    padding: 0px;
    padding-bottom: 0px;
    text-align: center;
    background-color: rgba(255,255,255,0);
}

.DataCurrency
{
    display: flex !important;
    text-align: center !important;
    place-content: center !important;
}

.Keikakumeisai_TotalDataContainer_Open
{
    max-height: 9999px;
}

.Keikakumeisai_ExpenseType
{
    border-radius: 20px;
    padding: 4px 10px;
    margin-left: 10px;
    width: 130px;
    text-align: center;
    cursor: pointer;
}

.Keikakumeisai_CostIncluding
{
    background-color: rgb(228, 223, 236);
}

.Keikakumeisai_NonCost
{
    background-color: rgb(253, 233, 217);
}

.Keikakumeisai_OtherCost
{
    background-color: rgb(240, 240, 240);
}

.Keikakumeisai_Other
{
    background-color: rgb(248, 248, 248);
}

.Keikakumeisai_DetailsContainer
{
    /* border-radius: 5px;
    display: grid;
    grid-template-columns: auto auto auto auto;
    grid-row-gap: 20px; */
    padding: 10px;
}

.GrayUnderline
{
    border-bottom: 1px solid #ddd;
}

.GrayUnderlineBright
{
    border-bottom: 1px solid #f1f1f1;
}

.Keikakumeisai_TotalCostGroupContainer + .Keikakumeisai_TotalCostGroupContainer
{
    margin-top: 10px;
}

.Keikakumeisai_TotalCostGroupContainerUnfold
{
    display: flex;
    align-items: center;
}

.Keikakumeisai_TotalCostGroup
{
    display: block;
}

.Keikakumeisai_TotalCostGroupHead
{
    margin-left: 10px;
    flex: 1.0;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}

.Keikakumeisai_TotalCostGroupHeadValue
{
    display: flex;
    flex: 1;
    place-content: end;
}

.Keikakumeisai_DetailsContainer .Keikakumeisai_Details:last-of-type
{
    margin-bottom: 10px;
}

.Keikakumeisai_TotalCostItem
{
    display: flex;
    transition: 0.2s;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
}

.Keikakumeisai_TotalCostItem:hover
{
    background-color: #f8f8f8;
}

.Keikakumeisai_HanbaisakiDataContainer div .Keikakumeisai_HanbaisakiBasicInfo:hover
{
    background-color: #f8f8f8;
}

.Keikakumeisai_TotalCostValue
{
    flex: 1;
    text-align: right;
}

.Keikakumeisai_TotalCostSubHead
{
    color: #aaa;
    margin-left: 8px;
}

.Keikakumeisai_TotalCostSubValue
{
    color: #aaa;
}
</style>